<header id="header" class="main-header bg-white py-2 py-lg-0">
  <div
    class="linear-loader"
    role="progressbar"
    aria-valuetext="Working…"
    aria-busy="true"
    *ngIf="routerIsLoadingData$ | async"
  ></div>
  <!-- WCAG skip to content link -->
  <a
    href="#content"
    scrollTo
    class="visually-hidden-focusable position-absolute top-0 left-0 right-0 w-100 bg-white text-center z-1 py-2"
    >{{ 'wcag.skipToMainContent' | translate }}
  </a>
  <!-- END WCAG skip to content link -->
  <div class="container-lg header-grid pt-lg-1" id="headerGrid">
    <primary-navbar-pending-sale-block
      *ngIf="showPendingSaleBlock$ | async"
      class="pending-sale"
    />

    <div
      id="logoArea"
      class="logo-area"
      *ngIf="
        (configurationService.isTabletOrLarger$ | async) &&
        (primaryLogoUrl$ | async) as primaryLogoUrl
      "
    >
      <img
        class="logo cursor-pointer"
        [src]="primaryLogoUrl"
        [routerLink]="logoRedirectUrl"
        alt="Logo"
      />
      <a
        class="navbar-brand"
        *ngIf="brandingConfig?.showSavBarBrandingName"
        [routerLink]="moduleConfigs.authModule.afterLoginSuccessRedirect"
        (click)="ticketingReset()"
      >
        {{ brandingConfig.brandingName }}
      </a>
    </div>

    <breadcrumb
      id="routeArea"
      *ngIf="!(configurationService.isTabletOrLarger$ | async)"
    ></breadcrumb>
    <primary-navbar-top-menu-block
      class="top-menu ms-auto"
      [member$]="member$"
      [hasEmployeeOrSupervisorRole$]="hasEmployeeOrSupervisorRole$"
      [moduleConfigs]="moduleConfigs"
      [showCartButton]="
        (configurationService.isTabletOrLarger$ | async) ||
        (showCartButton$ | async) !== false
      "
      (ticketingReset)="ticketingReset()"
      (logout)="onClickAction('logout')"
      (goLogin)="goLogin()"
      (userRoleSwitcher)="setShowUserRoleSwithcher($event)"
    ></primary-navbar-top-menu-block>

    <primary-navbar-desktop-main-menu-block
      *ngIf="
        configurationService.isTabletOrLarger$ | async;
        else mobileMainMenu
      "
      class="main-menu bg-white"
      [member$]="member$"
      [menuItems$]="menuItems$"
      [additionalMenuItems]="additionalMenuItemsFiltered() | async"
      [configurationService]="configurationService"
      (onLinkClick)="onLinkClick($event.item, $event.event)"
      (ticketingReset)="ticketingReset()"
    ></primary-navbar-desktop-main-menu-block>

    <ng-template #mobileMainMenu>
      <primary-navbar-mobile-main-menu-block
        class="main-menu bg-white"
        [member$]="member$"
        (onLinkClick)="onLinkClick($event.item, $event.event)"
        (onClickScan)="onClickScan()"
        (ticketingReset)="ticketingReset()"
      ></primary-navbar-mobile-main-menu-block>
    </ng-template>
  </div>
</header>
